(function() {
    'use strict';
    
a3_cabin_reports.factory('TravelValueSealFactory',  TravelValueSealFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name TravelValueSealFactory
    * @description 
    *   Manage Report's TravelValueSeals.
    * @ngInject
    */
function TravelValueSealFactory(GenericModalFactory) {

        /**
         * Initialiaze TravelValueSeal object 
         * @memberof TravelValueSealFactory
         */
		function TravelValueSeal() {
			this.Id = null;
			this.Position = null;
			this.SealFound = null;
			this.SealLeft = null;
		}

		var service = {
			createNew : createNew,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
		}
			
        /**
         * Create new  TravelValueSeal object 
         * @memberof TravelValueSealFactory
         */
		function createNew() {
			return GenericModalFactory.createNew(TravelValueSeal)
		}

        /**
         * Extend given TravelValueSeal object 
         * @memberof TravelValueSealFactory
         * @param {object} obj The TravelValueSeal object that will be extended
         * @returns {object} TravelValueSeal
         */    
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,TravelValueSeal)
		}

        /**
         * Delete TravelValueSeal object from given list
         * @memberof TravelValueSealFactory
         * @param {object} obj The TravelValueSeal object that will be deleted
         * @returns {array} TravelValueSeals
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
	
        /**
         * Extend given TravelValueSeal object List 
         * @memberof TravelValueSealFactory
         * @param {object} obj The TravelValueSeal object that will be extended
         * @returns {array} TravelValueSeals
         */  
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,TravelValueSeal)
		}

		return service;
	}

})();